const GCLID_PATTERN = /^[A-Za-z0-9_\-]+$/;

/**
 * Reads ?gclid=... from the current URL and forwards it to the backend so the
 * server can set the first-party attribution cookie on its origin.
 *
 * Must run synchronously at app bootstrap, BEFORE React Router mounts —
 * otherwise route redirects (e.g. `/` → `/dashboard` → `/login`) strip the
 * query string via history.replaceState before we can read it.
 */
export function captureGclidFromUrl(): void {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const gclid = params.get('gclid');
  if (!gclid || gclid.length === 0 || gclid.length >= 300 || !GCLID_PATTERN.test(gclid)) {
    return;
  }

  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';
  fetch(`${apiUrl}/health?gclid=${encodeURIComponent(gclid)}`, {
    credentials: 'include',
  }).catch(() => {});

  try {
    sessionStorage.setItem('dsgvoeasy_gclid', gclid);
  } catch {
    // sessionStorage may be unavailable (private mode, quota) — fine to skip
  }

  params.delete('gclid');
  const cleaned = params.toString();
  const newUrl = window.location.pathname + (cleaned ? `?${cleaned}` : '') + window.location.hash;
  window.history.replaceState({}, '', newUrl);
}
